<template>
  <div>
    <div class="d-flex align-center mb-4">
      <v-btn text small class="px-0" style="color: #777" @click="$router.back()">
        <v-icon small left>mdi-arrow-left</v-icon> Volver
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        v-if="puedeImprimir"
        text
        small
        :loading="loadingPDF"
        style="color: #777"
        @click="imprimir"
      >
        <v-icon small left>mdi-printer-outline</v-icon> Imprimir
      </v-btn>
    </div>

    <div v-if="loading" class="text-center py-12">
      <v-progress-circular indeterminate color="grey darken-1" size="32"></v-progress-circular>
    </div>

    <template v-else-if="comprobante">
      <!-- Header -->
      <div class="mb-6">
        <div class="d-flex align-center mb-1">
          <v-icon size="16" :color="esRecibo ? '#69db7c' : '#ff6b6b'" class="mr-2">
            {{ esRecibo ? 'mdi-arrow-down-circle-outline' : 'mdi-arrow-up-circle-outline' }}
          </v-icon>
          <span class="text-h6 font-weight-medium white--text">
            {{ esRecibo ? `Recibo #${comprobante.numero}` : comprobante.nroComprobante }}
          </span>
        </div>
        <div class="caption" style="color: #777">
          {{ moment(comprobante.fechaAlta).format('LLLL') }}
        </div>
        <div v-if="esRecibo && comprobante.nombreEntidad" class="caption mt-1" style="color: #555">
          {{ comprobante.nombreEntidad }}
        </div>
      </div>

      <!-- Total -->
      <div class="d-flex align-center justify-space-between py-4" style="border-bottom: 1px solid #2a2a2a">
        <span class="body-2" style="color: #aaa">Total</span>
        <span class="text-h6 font-weight-medium" style="color: #69db7c">
          {{ comprobante.total | convertPesoArg }}
        </span>
      </div>

      <!-- Formas de pago -->
      <div v-if="formasDePago.length > 0">
        <div class="caption mt-4 mb-2" style="color: #555; text-transform: uppercase; letter-spacing: 0.08em">Medio de pago</div>
        <div
          v-for="fp in formasDePago"
          :key="fp.id"
          class="d-flex align-center justify-space-between py-3"
          style="border-bottom: 1px solid #2a2a2a"
        >
          <span class="body-2" style="color: #e0e0e0">{{ fp.nombre || fp.formaDePago }}</span>
          <span v-if="fp.monto" class="body-2" style="color: #aaa">{{ fp.monto | convertPesoArg }}</span>
        </div>
      </div>

      <!-- Productos (solo comprobantes tipo venta) -->
      <div v-if="!esRecibo && comprobante.detalles_comprobante && comprobante.detalles_comprobante.length > 0">
        <div class="caption mt-4 mb-2" style="color: #555; text-transform: uppercase; letter-spacing: 0.08em">
          Productos ({{ comprobante.detalles_comprobante.length }})
        </div>
        <div
          v-for="c in comprobante.detalles_comprobante"
          :key="c.id"
          class="d-flex align-center justify-space-between py-3"
          style="border-bottom: 1px solid #2a2a2a"
        >
          <div>
            <div class="body-2" style="color: #e0e0e0">{{ c.descripcion_concepto }}</div>
            <div class="caption" style="color: #666">{{ c.precioUnitario | convertPesoArg }} × {{ c.cantidad }}</div>
          </div>
          <span class="body-2" style="color: #aaa">{{ (c.precioUnitario * c.cantidad) | convertPesoArg }}</span>
        </div>
      </div>
    </template>

    <div v-else-if="!loading" class="caption text-center py-12" style="color: #555">
      No se encontró el comprobante.
    </div>
  </div>
</template>

<script>
import ClienteCuentaCorrienteAPI from "@/api/clientes/cuentacorriente.js";


export default {
  name: "ClienteCuentaCorrienteMovimientosDetail",
  data() {
    return {
      comprobante: null,
      loading: false,
      loadingPDF: false,
    };
  },
  computed: {
    esRecibo() {
      return this.comprobante && this.comprobante.tipo === "recibo";
    },
    formasDePago() {
      if (!this.comprobante) return [];
      // El recibo usa formas_de_pago, el comprobante usa formasDePago
      return this.comprobante.formas_de_pago || this.comprobante.formasDePago || [];
    },
    puedeImprimir() {
      if (!this.comprobante) return false;
      return this.esRecibo
        ? Boolean(this.comprobante.recibo_id)
        : Boolean(this.comprobante.comprobante_id);
    },
  },
  methods: {
    // Recibos y comprobantes (NV, NC) tienen endpoints de PDF distintos.
    imprimir() {
      const pedirPDF = this.esRecibo
        ? ClienteCuentaCorrienteAPI.imprimirRecibo(this.comprobante.recibo_id)
        : ClienteCuentaCorrienteAPI.imprimirComprobante(this.comprobante.comprobante_id);

      this.loadingPDF = true;
      pedirPDF
        .then((response) => {
          const url = URL.createObjectURL(response.data);
          window.open(url);
          URL.revokeObjectURL(url);
        })
        .catch(() => {
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "error",
            text: "No se pudo generar el PDF.",
            icon: "mdi-alert",
            timeout: 3000,
          });
        })
        .finally(() => {
          this.loadingPDF = false;
        });
    },
    fetch(movimientoId) {
      this.loading = true;
      this.comprobante = null;
      ClienteCuentaCorrienteAPI.getMovimiento(
        this.$route.params.id_cliente,
        movimientoId
      )
        .then((response) => {
          this.comprobante = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    "$route.params": {
      handler(params) {
        this.fetch(params.movimiento_id);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
